export default "__VITE_ASSET__CGXRxMjE__"